import _tPartnerName from 'i18n!js/json/nls/universities';

import imgix from 'js/lib/imgix';
import { getLanguageCode } from 'js/lib/language';
import path from 'js/lib/path';

import constants from 'bundles/catalogP/constants';
import CatalogModel from 'bundles/catalogP/models/catalogModel';

const Partner = CatalogModel.extend({
  includes: {
    instructors: {
      resource: 'instructors.v1',
      attribute: 'instructorIds',
    },
    courses: {
      resource: 'courses.v1',
      attribute: 'courseIds',
    },
  },

  resourceName: 'partners.v1',
  urlPath: 'partners',

  getLink() {
    return this.get('homeLink') || path.join(constants.config.dir.home, this.get('shortName'));
  },

  get(key: $TSFixMe) {
    const parentValue = this.constructor.__super__.get.apply(this, arguments);
    switch (key) {
      case 'name':
        return _tPartnerName(parentValue);
      default:
        return parentValue;
    }
  },

  getName() {
    return this.get('name');
  },

  getUnlocalizedName() {
    return this.constructor.__super__.get.apply(this, 'name');
  },

  // TODO(jnam) see if it's possible to actually localize the abbr name,
  // instead of returning the localized full partner name.
  getLocalizedAbbrName() {
    const userLanguageIsEnglish = getLanguageCode() === 'en';

    let localizedAbbrName = this.get('abbrName');

    if (!userLanguageIsEnglish) {
      localizedAbbrName = _tPartnerName(this.get('name'));
    }

    return localizedAbbrName;
  },

  getPrettyWebsiteUrl() {
    let url = this.get('links').website;
    url = url.replace(/^.*:\/\//, '');
    url = url.replace(/\/$/, '');
    return url;
  },

  getSquareLogo(options: $TSFixMe) {
    if (this.get('squareLogo')) {
      return imgix.processImage(this.get('squareLogo'), options || {});
    }
  },

  getLogoForCdp() {
    return this.get('classLogo') || this.get('logo');
  },

  getLogoForCertificate(options: $TSFixMe) {
    const logo = this.get('rectangularLogo') || this.get('logo') || this.get('classLogo') || this.get('squareLogo');

    return imgix.processImage(logo, options || {});
  },
});

export default Partner;
